import { SITE_URL } from "../constants/APIKeys";

export const getNextUrl = (url: string) => {
  return `${SITE_URL}/api/redirect-toUrl?nextUrl=${url}`;
};

export const getPaymentUrl = (url: string) => {
  return `${SITE_URL}/api/redirect-from-payments?nextUrl=${url}`;
};
